import styled from 'styled-components';

export const NotFoundWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 10px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  p {
    margin-bottom: 10px;
  }
`;
